var HttpResponse = (function () {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function (response) {
        if (!response)
            return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}());
export { HttpResponse };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/protocol-http/dist-es/httpResponse.js
// module id = 653
// module chunks = 0